import { render } from "./order_settle.vue?vue&type=template&id=0c590416&scoped=true"
import script from "./order_settle.vue?vue&type=script&lang=js"
export * from "./order_settle.vue?vue&type=script&lang=js"

import "./order_settle.vue?vue&type=style&index=0&id=0c590416&lang=css"
import "./order_settle.vue?vue&type=style&index=1&id=0c590416&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c590416"]])

export default __exports__